module.exports = __webpack_public_path__ + "img/v3-rocket.3bb37d3e.svg";